import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
	selector: 'app-empty-state',
	standalone: true,
	templateUrl: './app-empty-state.component.html',
	styleUrls: ['./app-empty-state.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppEmptyStateComponent {
	title = input.required<string>();
	description = input<string | null>(null);
	compact = input(false);
	centered = input(true);
}
